import React from 'react';
import './ReadOnlyFieldset.css';

/**
 * Wraps a panel's editing controls so a platform reader (PlatformReadOnly, level 3) sees the
 * values but cannot change them. A disabled <fieldset> disables every input, select, textarea
 * and button inside it natively, so a control added later cannot forget the rule.
 * Read-side controls (expand, preview, filters) belong outside it.
 *
 * @param {boolean} readOnly - Disable everything inside and show the read-only note.
 */
const ReadOnlyFieldset = ({ readOnly = false, children }) => (
    <fieldset className="readonly-fieldset" disabled={readOnly}>
        {children}
    </fieldset>
);

/** The one-line explanation shown above a read-only panel. */
export const ReadOnlyNote = ({ readOnly = false }) => (readOnly ? (
    <p className="readonly-note" role="note">
        Read-only: your platform role can view these settings but not change them.
    </p>
) : null);

export default ReadOnlyFieldset;
